import SubscriptionModal from '../stripe/SubscriptionModal';

/**
 * Contenu verrouillé : ouvre directement le choix des offres (1 / 6 / 12 mois).
 * Avant, une première fenêtre « Contenu réservé aux abonnés » imposait un clic de plus
 * (« Voir les offres ») au moment même où le candidat voulait débloquer.
 * Props:
 *   scopeId    — ID du scope
 *   scopeSlug  — slug du scope
 *   scopeLabel — label affiché
 *   onClose    — callback pour fermer
 *   extraBody  — params supplémentaires (ex: { user_thematique_id })
 *   pricing    — scope (prix par durée)
 *   source     — provenance de l'ouverture (mesure du parcours)
 */
export default function SubscriptionWall({ scopeId, scopeSlug, scopeLabel, onClose, extraBody, pricing, source }) {
    return (
        <SubscriptionModal
            scopeId={scopeId}
            scopeLabel={scopeLabel || scopeSlug}
            onClose={onClose}
            subtitle="Ce contenu est inclus dans l'accès complet. Les QCM « Gratuit » restent en accès libre."
            extraBody={extraBody}
            pricing={pricing}
            source={source}
        />
    );
}
